export class TouchSwipe {
    constructor(el, callback) {
        if(el && callback) {
            this.swipedetect(el, callback)
        }
    }

    swipedetect(el, callback) {
        
          var touchsurface = el,
          swipedir,
          startX,
          startY,
          dist,
          distX,
          distY,
          threshold = 150,
          restraint = 100,
          allowedTime = 800,
          elapsedTime,
          startTime,
          handleswipe = callback || function(swipedir){}
        
          touchsurface.addEventListener('touchstart', (e) => {
              var touchobj = e.changedTouches[0]
              swipedir = 'none'
              dist = 0
              startX = touchobj.pageX
              startY = touchobj.pageY
              startTime = new Date().getTime()
              //e.preventDefault()
          }, false)
        
          touchsurface.addEventListener('touchmove', (e) => {/*e.preventDefault()*/}, false)
        
          touchsurface.addEventListener('touchend', (e) => {
              var touchobj = e.changedTouches[0]
              distX = touchobj.pageX - startX
              distY = touchobj.pageY - startY
              elapsedTime = new Date().getTime() - startTime
              if (elapsedTime <= allowedTime){
                  if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){
                      swipedir = (distX < 0)? 'left' : 'right'
                  }
                  else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){
                      swipedir = (distY < 0)? 'up' : 'down'
                  }
              }
              handleswipe(swipedir)
              //e.preventDefault()
          }, false)
      }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/touchSwipe.js